import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'
import $ from 'jquery';
import { useCart } from '../context/CartContext';

function Header() {
  const location = useLocation();
  const { cartItems, cartCount, cartTotal, removeFromCart } = useCart();

  const handleActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    })
    e.target.parentNode.classList += ' active';
  }
  const subActive = (e) => {
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    })
    e.target.parentNode.parentNode.parentNode.classList += ' active';
  }

  useEffect(() => {
    // Set active class based on current route
    const pathname = location.pathname;

    // Remove all active classes first
    document.querySelectorAll('.main-menu ul li').forEach(el => {
      el.classList.remove('active');
    });

    // Set active class based on current route
    if (pathname === '/' || pathname === '') {
      document.querySelector('.main-menu ul li:first-child').classList.add('active');
    } else if (pathname.startsWith('/shop')) {
      const shopMenuItem = document.querySelector('.main-menu ul li a[href="/shop"]');
      if (shopMenuItem) {
        shopMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/adoption') {
      const adoptionMenuItem = document.querySelector('.main-menu ul li a[href="/adoption"]');
      if (adoptionMenuItem) {
        adoptionMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/breeder' || pathname === '/breeder-details') {
      const breederMenuItem = document.querySelector('.main-menu ul li a[href="/breeder"]');
      if (breederMenuItem) {
        breederMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/blogs' || pathname === '/blog-details') {
      const blogsMenuItem = document.querySelector('.main-menu ul li a[href="/blogs"]');
      if (blogsMenuItem) {
        blogsMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/doglist') {
      const doglistMenuItem = document.querySelector('.main-menu ul li a[href="/doglist"]');
      if (doglistMenuItem) {
        doglistMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/contacts') {
      const contactsMenuItem = document.querySelector('.main-menu ul li a[href="/contacts"]');
      if (contactsMenuItem) {
        contactsMenuItem.parentNode.classList.add('active');
      }
    } else if (pathname === '/info') {
      const infoMenuItem = document.querySelector('.main-menu ul li a[href="/info"]');
      if (infoMenuItem) {
        infoMenuItem.parentNode.classList.add('active');
      }
    }
  }, [location.pathname]);
  useEffect(() => {


    //SubMenu Dropdown Toggle
    if ($('.menu-area li.menu-item-has-children ul').length) {
      $('.menu-area .navigation li.menu-item-has-children').append('<div class="dropdown-btn"><span class="fas fa-angle-down"></span></div>');

    }
    if ($('.mobile-menu').length) {

      var mobileMenuContent = $('.menu-area .main-menu').html();
      $('.mobile-menu .menu-box .menu-outer').append(mobileMenuContent);

      //Dropdown Button
      $('.mobile-menu li.menu-item-has-children .dropdown-btn').on('click', function () {
        $(this).toggleClass('open');
        $(this).prev('ul').slideToggle(500);
      });
      //Menu Toggle Btn
      $('.mobile-nav-toggler').on('click', function () {
        $('body').addClass('mobile-menu-visible');
      });

      //Menu Toggle Btn
      $('.menu-backdrop, .mobile-menu .close-btn').on('click', function () {
        $('body').removeClass('mobile-menu-visible');
      });
    }

    $(".navbar-toggle").on('click', function () {
      $(".navbar-nav").addClass("mobile_menu");
    });
    $(".navbar-nav li a").on('click', function () {
      $(".navbar-collapse").removeClass("show");
    });

    $(".header-search > a").on('click', function () {
      $(".search-popup-wrap").slideToggle();
      return false;
    });

    $(".search-close").on('click', function () {
      $(".search-popup-wrap").slideUp(500);
    });
  }, [])



  return (
    <header>
      <div className="header-top-area">
        <div className="container custom-container">
          <div className="row align-items-center">
            <div className="col-md-7">
              <div className="header-top-left">
                <ul>
                  {/* <li>Appelez-nous : 747-800-9880</li> */}
                  <li><i className="far fa-clock" />Heures d'ouverture : 9h00 - 17h00 (Lun - Ven)</li>
                </ul>
              </div>
            </div>
            <div className="col-md-5">
              <div className="header-top-right">
                <ul className="header-top-social">
                  <li className="follow">Suivez-nous :</li>
                  <li><a href="https://www.facebook.com/share/1NNNPkN18v/?mibextid=wwXIfr"><i className="fab fa-facebook-f" /></a></li>
                  <li><a href="https://www.instagram.com/kaki_tn?igsh=MjB0cXJiNTg0anYz&utm_source=qr"><i className="fab fa-instagram" /></a></li>
                  <li><a href="https://www.tiktok.com/@kaki_tn?_r=1&_t=ZS-9232ML67jxC"><i className="fab fa-tiktok" /></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="sticky-header" className="menu-area">
        <div className="container custom-container">
          <div className="row">
            <div className="col-12">
              <div className="mobile-nav-toggler"><i className="fas fa-bars" /></div>
              <div className="menu-wrap">
                <nav className="menu-nav show">
                  <div className="logo"><Link to="/"><img src="img/logo/blue_logo.png" alt="" /></Link></div>
                  <div className="navbar-wrap main-menu d-none d-lg-flex">
                    <ul className="navigation">
                      <li className="active "><Link to="/">Accueil</Link>

                      </li>
                      {/* <li><Link to="/doglist" onClick={(e) => handleActive(e)}>Liste des Chiens</Link></li> */}

                      <li >
                        <Link to="/shop" onClick={(e) => handleActive(e)}>Boutique</Link>
                      </li>

                      <li>
                        <Link to="/info" onClick={(e) => handleActive(e)}>Info</Link>
                      </li>

                      {/* <li><Link to="/adoption" onClick={(e) => handleActive(e)}>Adoption</Link></li>
                      <li className="menu-item-has-children"><Link to="/breeder" onClick={(e) => handleActive(e)}>Éleveur</Link>
                        <ul className="submenu">
                          <li><Link to="/breeder" onClick={(e) => subActive(e)}>Nos Éleveurs</Link></li>
                          <li><Link to="/breeder-details" onClick={(e) => subActive(e)}>Détails Éleveur</Link></li>
                        </ul>
                      </li> */}
                      {/* <li className="menu-item-has-children"><Link to="/blogs" onClick={(e) => handleActive(e)}>Blog</Link>
                        <ul className="submenu">
                          <li><Link to="/blogs" onClick={(e) => subActive(e)}>Notre Blog</Link></li>
                          <li><Link to="/blog-details" onClick={(e) => subActive(e)}>Détails Blog</Link></li>
                        </ul>
                      </li> */}
                      {/* <li><Link to="/contacts" onClick={(e) => handleActive(e)}>Contactez-Nous</Link></li> */}
                    </ul>
                  </div>
                  <div className="header-action d-none d-md-block">
                    <ul>
                      <li className="header-search"><a href="/#"><i className="flaticon-search" /></a></li>
                      <li className="header-shop-cart">
                        <Link to="/cart"><i className="flaticon-shopping-bag" /><span>{cartCount}</span></Link>
                        <ul className="minicart">
                          {cartItems.length === 0 ? (
                            <li>
                              <div className="cart-content">
                                <h4>Votre panier est vide</h4>
                              </div>
                            </li>
                          ) : (
                            cartItems.map((item) => (
                              <li className="d-flex align-items-start" key={item.cartId}>
                                <div className="cart-img">
                                  <Link to={`/shop/${item.product.slug || '#'}`}>
                                    <img src={item.options.images && item.options.images.length > 0 ? item.options.images[0] : (item.product.img || 'img/product/cart_p01.jpg')} alt="" />
                                  </Link>
                                </div>
                                <div className="cart-content">
                                  <h4><Link to={`/shop/${item.product.slug || '#'}`}>{item.product.name}</Link></h4>
                                  <div className="cart-price">
                                    <span className="new">{item.price} TND</span>
                                    <span> x {item.quantity}</span>
                                  </div>
                                  <div className="cart-product-options" style={{ fontSize: '12px', color: '#666', marginTop: '5px' }}>
                                    {item.options.color && <div className="cart-option">Couleur: {item.options.color}</div>}
                                    {item.options.size && <div className="cart-option">Taille: {item.options.size}</div>}
                                    {item.options.features && Object.entries(item.options.features).map(([key, value]) => (
                                      <div key={key} className="cart-option">{key}: {value}</div>
                                    ))}
                                  </div>
                                </div>
                                <div className="del-icon">
                                  <a href="/#" onClick={(e) => { e.preventDefault(); removeFromCart(item.cartId); }}>
                                    <i className="far fa-trash-alt" />
                                  </a>
                                </div>
                              </li>
                            ))
                          )}

                          <li>
                            <div className="total-price">
                              <span className="f-left">Total:</span>
                              <span className="f-right">{cartTotal.toFixed(2)} TND</span>
                            </div>
                          </li>
                          <li>
                            <div className="checkout-link">
                              <Link to="/cart">Panier</Link>
                              <Link className="black-color" to="/checkout">Commander</Link>
                            </div>
                          </li>
                        </ul>
                      </li>
                      <li className="header-btn"><Link to="/contacts" className="btn">Contactez-Nous <img src="img/icon/w_pawprint.png" alt="" /></Link></li>
                    </ul>
                  </div>
                </nav>
              </div>

              <div className="mobile-menu">
                <nav className="menu-box">
                  <div className="close-btn"><i className="fas fa-times" /></div>
                  <div className="nav-logo"><Link to="/"><img src="img/logo/blue_logo.png" alt="" title='true' /></Link>
                  </div>
                  <div className="menu-outer">

                  </div>
                  <div className="social-links">
                    <ul className="clearfix">
                      <li><a href="/#"><span className="fab fa-twitter" /></a></li>
                      <li><a href="/#"><span className="fab fa-facebook-square" /></a></li>
                      <li><a href="/#"><span className="fab fa-pinterest-p" /></a></li>
                      <li><a href="/#"><span className="fab fa-instagram" /></a></li>
                      <li><a href="/#"><span className="fab fa-youtube" /></a></li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="menu-backdrop" />

            </div>
          </div>
        </div>
        <div className="header-shape" style={{ backgroundImage: "url('img/bg/header_shape.png')" }} />
      </div>

      <div className="search-popup-wrap" tabIndex={-1} role="dialog" aria-hidden="true">
        <div className="search-close">
          <span><i className="fas fa-times" /></span>
        </div>
        <div className="search-wrap text-center">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="title">... Recherche Ici ...</h2>
                <div className="search-form">
                  <form>
                    <input type="text" name="search" placeholder="Tapez des mots-clés ici" />
                    <button className="search-btn"><i className="fas fa-search" /></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </header>
  )
}

export default Header